<template>
  <section>
    <h1 class="section-head">เพิ่มใบเสนอราคา</h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <router-link class="button is-danger is-pulled-left" :to="backPage"><i class="fas fa-arrow-left"></i>Back</router-link>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <button class="button is-success is-pulled-right" :class="loadingClass" @click="submit"><i class="fas fa-clipboard-list"></i>บันทึก</button>
          </div>
        </div>
      </div>
    </nav>

    <div class="margin-botton-10">
      <h1 class="section-sub-head">รายละเอียดลูกค้า</h1>
    </div>

    <div class="columns">
      <div class="column">

        <div class="field">
          <div class="field-body">
            <div class="field">
              <label class="label">Company</label>
              <b-autocomplete
                  v-model="quotation.company"
                  placeholder="ชื่อลูกค้า/บริษัท"
                  :clear-on-select="false"
                  :keep-first="true"
                  :open-on-focus="true"
                  :data="filteredCustomerObj"
                  field="name"
                  @select="selectedCustomer"
                  :disabled="customerList.length < 1"
                  >
              </b-autocomplete>
            </div>
            <div class="field"></div>

          </div>
        </div>
        <div class="field">
          <div class="field-body">
            <div class="field">
              <label class="label">Address</label>
              <b-input  v-model="quotation.address" placeholder="Address"></b-input>
            </div>
          </div>
        </div>

        <div class="field">
          <div class="field-body">
            <div class="field">
              <label class="label">ส่งถึง</label>
              <b-input  v-model="quotation.name" placeholder="name"></b-input>
            </div>
            <div class="field">
            </div>
          </div>
        </div>

      </div>
      <div class="column">
        <div class="field">
          <div class="field-body">
            <div class="field">
              <label class="label">Phone</label>
              <b-input  v-model="quotation.phone" placeholder="Phone"></b-input>
            </div>
            <div class="field">
              <label class="label">E-Mail</label>
              <b-input  v-model="quotation.email" placeholder="E-Mail"></b-input>
            </div>
          </div>
        </div>
        <div class="field">
          <div class="field-body">
            <div class="field">
              <label class="label">Fax</label>
              <b-input  v-model="quotation.fax" placeholder="Fax."></b-input>
            </div>
            <div class="field">
              <label class="label">Tax No.</label>
              <b-input  v-model="quotation.tax_no" placeholder="Tax No."></b-input>
            </div>
          </div>
        </div>
      </div>
    </div>




    <div class="margin-botton-10 section-sub-head columns">
        <h1 class="column">รายการสินค้า</h1>
        <div class="column">
          <div class="field has-addons has-addons-right">
            <div class="control">
              <b-input placeholder="Search..." v-model="search_query" type="search" icon="search" icon-pack="fas" width="250"></b-input>
            </div>
            <div class="control">
              <button class="button" @click="init">Refresh</button>
            </div>
          </div>
        </div>
    </div>

    <div>
      <b-table
        :data="filteredData"
        :hoverable="true"
        :loading="isLoading"

        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :narrowed="true"

        v-if="products.length > 0 && !isLoading"
        class="table-style"
      >
        <template slot-scope="props">
          <b-table-column field="name" label="ชื่อผลิตภัณฑ์" width="250">
              {{ props.row.name }}
          </b-table-column>

          <b-table-column field="price_sell" label="ราคาขาย" width="150">
              {{ parseFloat((quotation.type == "other" ? props.row.general_price_sell:props.row.price_sell)).formatMoney(2) }} บาท/{{ props.row.unit_sell_text }}
          </b-table-column>

          <b-table-column label="ส่วนลด(%)" width="60">
            <div class="field has-addons">
              <p class="control">
                <b-input size="is-small" placeholder="ส่วนลด %" v-model="discount[props.row.id]"></b-input>
              </p>
            </div>
          </b-table-column>

          <b-table-column label="ส่วนลด(฿)" width="60">
            <div class="field has-addons">
              <p class="control">
                <b-input size="is-small" placeholder="ส่วนลด ฿" v-model="discount_baht[props.row.id]"></b-input>
              </p>
            </div>
          </b-table-column>

          <b-table-column field="price_sell" label="จำนวนสั่ง"  width="120">
            <div class="field has-addons">
              <p class="control">
                <b-input size="is-small" placeholder="จำนวนสั่ง" v-model="amount[props.row.id]"></b-input>
              </p>
              <p class="control">
                <button class="button is-static is-small">
                  {{ props.row.unit_sell_text }}
                </button>
              </p>
            </div>
          </b-table-column>

          <b-table-column field="name" label="รวม" width="150">
              {{ parseFloat(amount[props.row.id] ? ((amount[props.row.id]*(quotation.type == "other" ? props.row.general_price_sell:props.row.price_sell)) - (amount[props.row.id]*(quotation.type == "other" ? props.row.general_price_sell:props.row.price_sell)) * ((discount[props.row.id] ? discount[props.row.id] : 0) / 100) - (discount_baht[props.row.id] ? discount_baht[props.row.id] : 0)) : 0).formatMoney(2) }} บาท
          </b-table-column>

          <b-table-column field="remark" label="Remark" width="300">
            <div class="field">
              <p class="control">
                <b-input size="is-small" placeholder="Remark" v-model="remark[props.row.id]"></b-input>
              </p>
            </div>
          </b-table-column>


        </template>
      </b-table>

      <div class="notification has-text-centered" v-else>ไม่มีรายการผลิตภัณฑ์</div>

    </div>

  </section>
</template>

<script>
  import Request from '@/libraries/request';
  import ProductModel from '@/model/product_model';
  import SupplierModel from '@/model/supplier_model';
  import CustomerModel from '@/model/customer_model';
  import QuotationModel from '@/model/quotation_model';
  import Const from '@/const/const';

  export default {
    data(){
      return {
        quotation: {
          company: ""
        },
        products: [],
        customerList: [],
        discount: [],
        discount_baht: [],
        amount: [],
        total: [],
        remark: [],
        isLoading: true,
        loadingClass: "",
        backPage: "/quotation",

        isPaginated: true,
        isPaginationSimple: false,
        currentPage: 1,
        perPage: 20,
        search_query: "",
      }
    },
    mounted() {
      this.isLoading = true;
      this.init();
    },
    computed: {
      filteredCustomerObj() {
          return this.customerList.filter((option) => {
            if(option.name.toString().toLowerCase().indexOf(this.quotation.company.toLowerCase()) >= 0){
                    return option;
            }else{
              return false;
            }

          });
      },
      filteredData: function() {
        return this.products.filter(product => {
          return (
                  (product.name && product.name.toLowerCase().includes(this.search_query.toLowerCase()))
                )
        })
      }
    },
    methods: {
      async init(){
        this.isLoading = true;
        this.customerList  = await CustomerModel.get_all_customer();
        try{
          if(this.$route.params.id){
            const quotation = await QuotationModel.get_quotation(this.$route.params.id);
            this.quotation = quotation[0]
            let amount = [];
            let discount = [];
            let discount_baht = [];
            let total = [];
            let remark = [];
            for (const [key, item] of Object.entries(this.quotation.items)) {
              amount[item.pro_id] = item.amount;
              discount[item.pro_id] = item.discount;
              discount_baht[item.pro_id] = item.discount_baht;
              remark[item.pro_id] = item.remark;
            }
            this.amount = amount;
            this.discount = discount;
            this.discount_baht = discount_baht;
            this.remark = remark;

            for (const [key, value] of Object.entries(this.customerList)) {
              if(value.id == this.quotation.cus_id){
                this.selectedCustomer(value);
              }
            }
          }
          this.products = await ProductModel.get_all_product();
        }catch(e){
          this.$buefy.snackbar.open(e.message);
          this.$router.push('/quotation');
        }
        this.isLoading = false;
      },
      selectedCustomer(customer){
        if(customer == null){
          return;
        }
        this.quotation.cus_id = customer.id||0;
        this.quotation.company = customer.name;
        this.quotation.address = customer.address;
        this.quotation.phone = customer.phone;
        this.quotation.email = customer.email;
        this.quotation.fax = customer.fax;
        this.quotation.tax_no = customer.tax_no;
        this.quotation.type = customer.type;
      },
      submit() {
        this.loadingClass = "is-loading";
        this.isLoading = true;
        let data = Object.assign({}, this.quotation);
        let customerData = [];
        data.items = [];
        if(this.$route.params.id){
          data.id = this.$route.params.id;
        }
        if(this.quotation.company == ""){
          this.$buefy.snackbar.open('โปรดเลือกรายการลูกค้า');
          this.isLoading = false;
          this.loadingClass = "";
          return
        }
        if(this.amount == undefined || this.amount.length < 1){
          this.$buefy.snackbar.open('ไม่มีการใส่จำนวนในรายการสิ้นค้าใด');
          this.isLoading = false;
          this.loadingClass = "";
          return
        }

        for (const [key, value] of Object.entries(this.amount)) {
          let item = {};
          item.id = key;
          item.amount = value;
          item.discount = this.discount[key] ? this.discount[key]:0;
          item.discount_baht = this.discount_baht[key] ? this.discount_baht[key]:0;
          item.remark = this.remark[key] ? this.remark[key]:"";
          data.items.push(item);
        }

        //Add or Update Customer
        customerData["id"] = this.quotation.cus_id;
        customerData["to"] = this.quotation.to;
        customerData["name"] = this.quotation.company;
        customerData["address"] = this.quotation.address;
        customerData["phone"] = this.quotation.phone;
        customerData["email"] = this.quotation.email;
        customerData["fax"] = this.quotation.fax;
        customerData["tax_no"] = this.quotation.tax_no;
        customerData["type"] = (this.quotation.cus_id == 0 ? "other":this.quotation.type);
        Request.post('customer/add',customerData, (res) => {
          if(!res.data.status){
            this.$buefy.snackbar.open('อัพเดทข้อมูลลูกค้าไม่สำเร็จ!');
          }else{
            data.cus_id = res.data.data.id;
            Request.post('quotation/add',data,(res) => {
              this.isLoading = false;
              this.loadingClass = "";
              if(res.data.status){
                if(res.data.data.id){
                  this.$buefy.snackbar.open('บันทึกสำเร็จ!');
                  this.$router.push({ path: '/quotation/view/'+res.data.data.id })
                }else{
                  this.$router.push({ path: '/quotation'})
                }
              }
            });
          }
        });


      },
    }
  }
</script>


<style scoped>
  .table-style {
    font-size: 0.8rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Quotation/add.vue